var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isConnected,
          expression: "isConnected",
        },
      ],
    },
    [
      _vm.canStartDebug
        ? _c(
            "div",
            {
              staticClass: "component-action dev-client-action",
              on: { click: _vm.startDebug },
            },
            [
              _vm.busy
                ? _c("VIcon", {
                    attrs: { icon: "mdi-network-outline", size: 16 },
                  })
                : _c("VIcon", {
                    attrs: { icon: "mdi-play-network-outline", size: 16 },
                  }),
              _vm._v(
                "\n    " + _vm._s(_vm.busy ? "启动中" : "开始调试") + "\n  "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canStopDebug
        ? _c(
            "div",
            {
              staticClass: "component-action dev-client-action",
              on: { click: _vm.stopDebug },
            },
            [
              _vm.busy
                ? _c("VIcon", {
                    attrs: { icon: "mdi-network-outline", size: 16 },
                  })
                : _c("VIcon", {
                    attrs: { icon: "mdi-minus-network-outline", size: 16 },
                  }),
              _vm._v(
                "\n    " + _vm._s(_vm.busy ? "停止中" : "停止调试") + "\n  "
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }